import React from 'react';
import { observer } from 'mobx-react-lite';
import { History } from 'history';
import { TAB_BUTTON_TYPE } from '../../../global/constants';
import { isEmpty } from '../../../helpers/common';
import { ROUTES } from '../../../routes/urls';
import { AccountingViewState, CurrentProject, CurrentWorkspace } from '../../../interfaces/ProjectInterface';
import Tabs from '../../tabs';

interface AccountingProjectTabsProps {
  currentProject: CurrentProject;
  currentWorkspace: CurrentWorkspace;
  history: History;
  params: { id: string };
  view: AccountingViewState;
}

const AccountingProjectTabs: React.FC<AccountingProjectTabsProps> = observer(({
  currentProject,
  currentWorkspace,
  history,
  params,
  view
}) => {
  const projectTabs = [
    {
      title: 'Overview',
      path: 'overview',
      show: () => isEmpty(currentWorkspace?.customerId) && !currentWorkspace?.customerRole,
      isActive: view.isOverview
    },
    { title: 'Tasks', path: 'tasks', show: () => true, isActive: view.isTask },
    { title: 'Milestones', path: 'milestone', show: () => currentProject?.isMilestone, isActive: view.isMilestone },
    { title: 'Files', path: 'files', show: () => true, isActive: view.isFile },
    { title: 'Messages', path: 'messages', show: () => true, isActive: view.isMessages }
  ];

  return (
    <>
      {projectTabs
        .filter((tab) => tab.show())
        .map((tab) => (
          <Tabs
            key={tab.path}
            title={tab.title}
            variant={TAB_BUTTON_TYPE.STANDARD}
            size='small'
            isActive={tab.isActive}
            onClick={() => history.push(ROUTES.PROJECT_TAB.replace(':id', params.id || '').replace(':tab', tab.path))}
          />
        ))}
    </>
  );
});

export default AccountingProjectTabs;
